var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons /  Webapp UI"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11077_24849",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11077_24849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hourglass_top",
    d: "M5.43307 13.3307H10.5664V11.3307C10.5664 10.5863 10.3193 9.94184 9.82507 9.3974C9.33041 8.85295 8.72196 8.58073 7.99974 8.58073C7.27752 8.58073 6.66907 8.85295 6.17441 9.3974C5.68018 9.94184 5.43307 10.5863 5.43307 11.3307V13.3307ZM3.06641 14.3307V13.3307H4.43307V11.3307C4.43307 10.6085 4.6193 9.94184 4.99174 9.33073C5.36374 8.71962 5.87196 8.27517 6.51641 7.9974C5.87196 7.71962 5.36374 7.27517 4.99174 6.66406C4.6193 6.05295 4.43307 5.38628 4.43307 4.66406V2.66406H3.06641V1.66406H12.9331V2.66406H11.5664V4.66406C11.5664 5.38628 11.3804 6.05295 11.0084 6.66406C10.636 7.27517 10.1275 7.71962 9.48307 7.9974C10.1275 8.27517 10.636 8.71962 11.0084 9.33073C11.3804 9.94184 11.5664 10.6085 11.5664 11.3307V13.3307H12.9331V14.3307H3.06641Z",
    fill: "#F28B4D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.698f6d9a93183e4200563b779bb9e513.svg";
export { ForwardRef as ReactComponent };